import TimeUtils from '@business/utils/time';
import { useStore } from '@data/other/withStore';
import { observer } from 'mobx-react';
import {
  useLocation,
  useNavigate as useReactRouterDomNavidate,
} from 'react-router-dom';

import store from '@data/stores/Store';
import { autorun, IReactionDisposer } from 'mobx';
import { useEffect, useState } from 'react';

let queryParams = '';

const storeChecker = autorun(() => {
  const { language, currency } = store.environment;
  const { checkin, checkout, code } = store.components.promoCode.value;

  const query = {};
  if (checkin) {
    query['checkin'] = TimeUtils.format(checkin);
  }
  if (checkout) {
    query['checkout'] = TimeUtils.format(checkout);
  }
  if (code) {
    query['code'] = code;
  }
  if (language) {
    query['language'] = language;
  }
  if (currency) {
    query['currency'] = currency;
  }

  const queryString = Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join('&')
    .trim();
  queryParams = queryString.length > 0 ? '?' + queryString : '';
});

export const useNavigate = () => {
  const reactRouterDomNavigate = useReactRouterDomNavidate();

  const navigate = (path: string) => {
    const url = path + queryParams;
    reactRouterDomNavigate(url);
  };

  return navigate;
};
